<template>
  <a-form ref='form' :model='search' class="m-b-40" :initialValues="search" :onFinish='pageSearchChange'
    layout='inline'>
    <a-form-item>
      <a-radio-group v-model:value="search.day_type" button-style="solid" @change="onChangeDay">
        <a-radio-button :value="1">最近7天</a-radio-button>
        <a-radio-button :value="2">最近30天</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="" name=''>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-row :gutter="20">
    <a-col :span="8">
      <echartCake :echartsData='echartData' v-if='!listLoading'></echartCake>
    </a-col>
    <a-col :span="16">
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='type' :columns='columns'
        :data-source='echartData.list'></a-table>
    </a-col>
  </a-row>
  <div class="m-t-40">
    <div class="s_flex_bian_c m-b-25">
      <p><text v-if='time.length > 0'>{{time[0]}} 至 {{time[1]}}</text></p>
      <a-select class='m-r-10' v-model:value="search.first" :style="{width:'140px'}" placeholder="请选择" @change='firstChange'>
        <a-select-option :value="1">首次交易客户</a-select-option>
        <a-select-option :value="2">复购客户</a-select-option>
      </a-select>
    </div>
    <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
  </div>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getLevelList, levelDel, setlevelAdd, levelEdit } from "@/api/store";
  import { getOrderStatistics } from "@/api/order";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    type: 4,
    day_type: 1,
    start_time: '',
    end_time: '',
    key_type: '',
    first: 1
  };
  export default {
    components: {  },
    name: 'customerList',
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        time: [],
        echartData: {},
        listLoading: true,
        columns: [
          {
            title: '',
            dataIndex: "type",
            key: "type",
            align: 'center'
          },
          {
            title: "下单人数",
            dataIndex: "order_pay_user_count",
            key: "order_pay_user_count",
            align: 'center'
          },
          {
            title: "成交人数",
            dataIndex: "order_user_count",
            key: "order_user_count",
            align: 'center'
          },
          {
            title: "成交金额",
            dataIndex: "order_pay_price_count",
            key: "order_pay_price_count",
            align: 'center'
          },
          {
            title: '成交订单占比',
            dataIndex: "percentage",
            key: "percentage",
            align: 'center'
          }
        ]
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const onChangeDay = () => {
        state.listLoading = true;
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        initData(search.value);
      }
      const onChange = (e) => {
        state.listLoading = true;
        search.value.start_time = e[0];
        search.value.end_time = e[1];
        search.value.day_type = 0
      }
      const firstChange = () =>{
        initData(search.value);
      }
      // 页面筛选项搜索
      const pageSearchChange = () => {
        initData(search.value);
      };
      const initData = async (values) => {
        let res = await getOrderStatistics(values).then(res => res.data);
        if (iscode(res)) {
          res.data.dataName = ['下单人数', '成交人数', '成交金额（元）']
          res.data.series = [
            {
              name: '下单人数',
              data: res.data.order_pay_user_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '成交人数',
              data: res.data.order_user_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '成交金额（元）',
              data: res.data.order_pay_price_count,
              type: 'line',
              symbolSize: 6,smooth: true
            }
          ]
          state.echartData = res.data;

        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        onChangeDay,
        onChange,
        pageSearchChange,
        firstChange
      };
    },
  };
</script>